import { render, staticRenderFns } from "./ProgressWidget.vue?vue&type=template&id=40a5d23b"
import script from "./ProgressWidget.vue?vue&type=script&lang=js"
export * from "./ProgressWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgressWidget.vue?vue&type=style&index=0&id=40a5d23b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports